<template>
  <div :style="`background-color: ${business.color} ;`">
    <v-layout column justify-center align-center style="min-height: 100vh" >
      <v-flex xs12 sm8 md6>
        <div class="text-center my-1">
          <router-link :to="`/i/${id}/es`">
            <v-img height="100" width="100" src='/static/images/esp.png' />
          </router-link>
        </div>
        <div class="text-center my-1">
          <router-link :to="`/i/${id}/en`">
            <v-img height="100" width="100" src='/static/images/eng.png' />
          </router-link>
        </div>
        <div class="text-center my-1">
          <router-link :to="`/i/${id}/de`">
            <v-img height="100" width="100" src='/static/images/deu.png' />
          </router-link>
        </div>
        <div class="text-center my-1">
          <router-link :to="`/i/${id}/fr`">
            <v-img height="100" width="100" src='/static/images/fr.png' />
          </router-link>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	name: 'Index',
	data() {
    return {
      id: this.$route.params.id
    };
  },
	created(){
		this.setLocalBusiness(this.id)
	},
	methods: {
		...mapActions('businessModule',["setLocalBusiness",]),
	},
	computed:{
		...mapState('businessModule',["business", "businesses"]),
	}
}
</script>
